import { gql } from '@apollo/client';

export const DASHBOARD_STATS_FIELDS = gql`
   fragment DashboardStatsFields on DashboardStats {
      totalApplications
      pendingApplications
      completedApplications
      applicationTypes {
         type
         count
      }
      statusData {
         status
         count
      }
      weeklyVolume {
         day
         count
      }
   }
`;